import LoadingBlock from "../LoadingBlock/LoadingBlock";
import "./KpiCard.css";

export default function KpiCard({ title, value, subtitle, loading = false }) {
  return (
    <LoadingBlock loading={loading} height={92} withBorder={false} p={0}>
      <div className="kpi-card">
        <span>{title}</span>
        <h2>{value}</h2>
        <small>{subtitle}</small>
      </div>
    </LoadingBlock>
  );
}
